/* eslint-disable @typescript-eslint/naming-convention */
import { type SizeType } from 'antd/es/config-provider/SizeContext';
import colors from 'core/constants/colors';

const viewportWidth = window.innerWidth;

const ConfigStyle = {
  theme: {
    token: {
      fontFamily: `'Noto Sans', 'sans-serif'`,
      fontSize: 16,
      colorBgBase: colors.white,
      colorBgContainer: colors['neutral-10'],
      colorBorder: colors['neutral-60'],
      colorBgContainerDisabled: colors['neutral-40'],
      colorSuccess: colors['success-500'],
      colorError: colors['danger-500'],
      colorPrimary: colors['primary-700'],
      colorPrimaryHover: colors['primary-500'],
      colorTextDisabled: colors['neutral-100'],
      colorTextPlaceholder: colors['neutral-300'],
    },
    components: {
      Button: {
        borderRadius: 4,
        contentFontSize: 14,
        primaryShadow: 'none',
        defaultShadow: 'none',
      },
      Layout: {
        headerColor: colors.mutedBlack,
        bodyBg: colors.formColor,
      },
      Tooltip: {
        // colorText: colors['neutral-500'],
        colorBgSpotlight: colors.white,
      },
      Table: {
        colorTextHeading: colors.tableHeaderColor,
        headerBg: colors.tableHeadBg,
        cellFontSize: 14,
        rowHoverBg: colors.tableHoverBg,
        borderColor: colors.tableBorder,
        borderRadius: 58,
        padding: 10,
      },
      ...(viewportWidth > 900 && {
        Menu: {
          // subMenuItemBg: colors.white,
          // itemSelectedColor: colors.black,
          // itemSelectedBg: colors.secondary,
          // itemBg: colors.white,
          // itemColor: '#6c6666',
          // itemHoverColor: colors.black,
          // itemHoverBg: colors.secondary,

          subMenuItemBg: colors.white,
          itemSelectedColor: colors.white,
          itemSelectedBg: colors['primary-500'],
          itemBg: colors.mutedPrimary,
          itemColor: colors.titleColor,
          itemHoverColor: colors['neutral-500'],
          itemHoverBg: colors['primary-50'],
          itemActiveBg: colors['primary-500'],
        },
      }),
      // Card: {
      //   colorTextHeading: colors.heading,
      //   colorBgContainer: '#fff',
      //   colorPrimary: '#001E4C',
      // },
      // Form: {
      //   colorTextHeading: 'black',
      //   labelColor: 'black',
      // },
      Input: {
        activeBorderColor: colors['primary-500'],
        colorText: colors['neutral-800'],
        colorBorderSuccess: colors['success-500'],
      },
      Checkbox: {
        colorPrimary: colors.primary,
      },
      Select: {
        selectorBg: colors['neutral-20'],
        colorBorder: colors.selectBorder,
        optionSelectedFontWeight: 400,
        colorBgElevated: colors.white,
        optionSelectedBg: colors.white,
        optionSelectedColor: colors['primary-500'],
        optionSelectedBorderColor: colors['primary-100'],
        optionActiveBg: colors['primary-50'],
        optionFontSize: 16,
      },
      // Radio: {
      //   buttonColor: colors.primary,
      //   buttonBg: colors.primary,
      //   buttonCheckedBg: colors.primary,
      //   colorPrimaryActive: colors.primary,
      //   buttonSolidCheckedColor: colors.primary,
      //   buttonSolidCheckedBg: colors.primary,
      //   buttonSolidCheckedActiveBg: colors.primary,
      //   // radioSize: 16,
      //   // dotSize: 8,
      // },
      DatePicker: {
        colorText: colors['neutral-300'], // default text
        colorTextDisabled: colors['neutral-80'], // disabled dates
        colorPrimary: colors['primary-300'], // selected date background
      },
      //   Dropdown: {
      //     colorTextPlaceholder: colors.placeholder,
      //   },
      Typography: {
        colorTextHeading: colors.menuTitleColor,
        // fontFamily: 'Inter',
      },
      Tree: {},
      Segmented: {
        itemSelectedBg: colors['primary-700'],
        itemSelectedColor: colors.white,
        trackBg: colors.subheading,
      },
    },

    // h2: {
    //   fontWeightStrong: true,
    // },
  },

  componentSize: 'large' as SizeType,
  labelfontWeight: '500',
  labelColor: colors['neutral-700'],
  labelfontSize: '14px',
  colors,
  contentProps: {
    className: 'custom-form',
    // bordered: false,
    // bodyStyle: {
    //   backgroundColor: 'transparent',
    //   padding: 0,
    // },
    // style: {
    //   backgroundColor: 'transparent',
    //   boxShadow: 'none',
    // },
  },
};

export default ConfigStyle;
